import henceforthApi from "./henceforthApi";
import profile_placeholder from "../assets/images/profile_placeholder.png";

export const getDefaultTimeslot = [
    {
        local: "00:00",
        title: "12:00 AM",
        minutes: 0
    }, {
        local: "00:30",
        title: "12:30 AM",
        minutes: 30
    }, {
        local: "01:00",
        title: "01:00 AM",
        minutes: 60
    }, {
        local: "01:30",
        title: "01:30 AM",
        minutes: 90
    }, {
        local: "02:00",
        title: "02:00 AM",
        minutes: 120
    }, {
        local: "02:30",
        title: "02:30 AM",
        minutes: 150
    }, {
        local: "03:00",
        title: "03:00 AM",
        minutes: 180
    }, {
        local: "03:30",
        title: "03:30 AM",
        minutes: 210
    }, {
        local: "04:00",
        title: "04:00 AM",
        minutes: 240
    }, {
        local: "04:30",
        title: "04:30 AM",
        minutes: 270
    }, {
        local: "05:00",
        title: "05:00 AM",
        minutes: 300
    }, {
        local: "05:30",
        title: "05:30 AM",
        minutes: 330
    }, {
        local: "06:00",
        title: "06:00 AM",
        minutes: 360
    }, {
        local: "06:30",
        title: "06:30 AM",
        minutes: 390
    }, {
        local: "07:00",
        title: "07:00 AM",
        minutes: 420
    }, {
        local: "07:30",
        title: "07:30 AM",
        minutes: 450
    }, {
        local: "08:00",
        title: "08:00 AM",
        minutes: 480
    }, {
        local: "08:30",
        title: "08:30 AM",
        minutes: 510
    }, {
        local: "09:00",
        title: "09:00 AM",
        minutes: 540
    }, {
        local: "09:30",
        title: "09:30 AM",
        minutes: 570
    }, {
        local: "10:00",
        title: "10:00 AM",
        minutes: 600
    }, {
        local: "10:30",
        title: "10:30 AM",
        minutes: 630
    }, {
        local: "11:00",
        title: "11:00 AM",
        minutes: 660
    }, {
        local: "11:30",
        title: "11:30 AM",
        minutes: 690
    }, {
        local: "12:00",
        title: "12:00 PM",
        minutes: 720
    }, {
        local: "12:30",
        title: "12:30 PM",
        minutes: 750
    }, {
        local: "13:00",
        title: "01:00 PM",
        minutes: 780
    }, {
        local: "13:30",
        title: "01:30 PM",
        minutes: 810
    }, {
        local: "14:00",
        title: "02:00 PM",
        minutes: 840
    }, {
        local: "14:30",
        title: "02:30 PM",
        minutes: 870
    }, {
        local: "15:00",
        title: "03:00 PM",
        minutes: 900
    }, {
        local: "15:30",
        title: "03:30 PM",
        minutes: 930
    }, {
        local: "16:00",
        title: "04:00 PM",
        minutes: 960
    }, {
        local: "16:30",
        title: "04:30 PM",
        minutes: 990
    }, {
        local: "17:00",
        title: "05:00 PM",
        minutes: 1020
    }, {
        local: "17:30",
        title: "05:30 PM",
        minutes: 1050
    }, {
        local: "18:00",
        title: "06:00 PM",
        minutes: 1080
    }, {
        local: "18:30",
        title: "06:30 PM",
        minutes: 1110
    }, {
        local: "19:00",
        title: "07:00 PM",
        minutes: 1140
    }, {
        local: "19:30",
        title: "07:30 PM",
        minutes: 1170
    }, {
        local: "20:00",
        title: "08:00 PM",
        minutes: 1200
    }, {
        local: "20:30",
        title: "08:30 PM",
        minutes: 1230
    }, {
        local: "21:00",
        title: "09:00 PM",
        minutes: 1260
    }, {
        local: "21:30",
        title: "09:30 PM",
        minutes: 1290
    }, {
        local: "22:00",
        title: "10:00 PM",
        minutes: 1310
    }, {
        local: "22:30",
        title: "10:30 PM",
        minutes: 1340
    }, {
        local: "23:00",
        title: "11:00 PM",
        minutes: 1370
    }
]
export const getStaticDay = [
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "10",
    "11",
    "12",
    "13",
    "14",
    "15",
    "16",
    "17",
    "18",
    "19",
    "20",
    "21",
    "22",
    "23",
    "24",
    "26",
    "27",
    "28",
    "29",
    "30",
    "31"
]
export const getStaticMonth = [
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "10",
    "11",
    "12"
]
export const getStaticYear = [
    "1990",
    "1991",
    "1992",
    "1993",
    "1994",
    "1995",
    "1996",
    "1997",
    "1998",
    "1999",
    "2000",
]
export const getRole = (role) => {
    let roleName = role
    switch (role) {

        case 1:
            roleName = "User"
            break;
        case 3:
            roleName = "Admin"
            break;
        case 4:
            roleName = "Super admin"
            break;
        default:
            break;
    }
    return roleName
}
export const getTemplateValue = (value) => {
    let finalStr = ""
    let rowTempleteArr = String(value).split(" ")
    rowTempleteArr.forEach(element => {
        switch (String(element).trim()) {
            case "%FULL_NAME%":
                finalStr += String(element).replace("%FULL_NAME%", `<button class='btn btn-aus mt-2'>full_name</button>`)
                break;
            case "%FIRST_NAME%":
                finalStr += String(element).replace("%FIRST_NAME%", `<button class='btn btn-aus mt-2'>first_name</button>`)
                break;
            case "%EMAIL%":
                finalStr += String(element).replace("%EMAIL%", `<button class='btn btn-aus mt-2'>email</button>`)
                break;
            case "%PASSWORD%":
                finalStr += String(element).replace("%PASSWORD%", `<button class='btn btn-aus mt-2'>password</button>`)
                break;
            case "%FACILITY_NAME%":
                finalStr += String(element).replace("%FACILITY_NAME%", `<button class='btn btn-aus mt-2'>facility</button>`)
                break;
            case "%FACILITY_ADDRESS%":
                finalStr += String(element).replace("%FACILITY_ADDRESS%", `<button class='btn btn-aus mt-2'>facility_address</button>`)
                break;
            case "%BOOKING_PRICE%":
                finalStr += String(element).replace("%BOOKING_PRICE%", `<button class='btn btn-aus mt-2'>BOOKING_PRICE</button>`)
                break;
            case "%BOOKING_STARTS%":
                finalStr += String(element).replace("%BOOKING_STARTS%", `<button class='btn btn-aus mt-2'>BOOKING_STARTS</button>`)
                break;
            case "%BOOKING_ENDS%":
                finalStr += String(element).replace("%BOOKING_ENDS%", `<button class='btn btn-aus mt-2'>BOOKING_ENDS</button>`)
                break;
            case "%BOOKING_DURATION%":
                finalStr += String(element).replace("%BOOKING_DURATION%", `<button class='btn btn-aus mt-2'>BOOKING_DURATION</button>`)
                break;
            case "%BOOKING_DATE%":
                finalStr += String(element).replace("%BOOKING_DATE%", `<button class='btn btn-aus mt-2'>BOOKING_DATE</button>`)
                break;
            case "%LOGO_SMALL%":
                finalStr += String(element).replace("%LOGO_SMALL%", `<button class='btn btn-aus mt-2'>LOGO_SMALL</button>`)
                break;
            case "%LOGO_LARGE%":
                finalStr += String(element).replace("%LOGO_LARGE%", `<button class='btn btn-aus mt-2'>LOGO_LARGE</button>`)
                break;
            default:
                finalStr += `${element} `
                break;
        }
    })
    return finalStr
}

/**
 * Get user profile image URL
 * @param {string} profilePic - The profile picture path or URL
 * @param {string} size - Image size: 'small', 'medium', or 'original' (default: 'original')
 * @returns {string} - Full image URL or placeholder
 * 
 * Logic:
 * - If profilePic is a full URL (starts with http/https), return as-is
 * - If profilePic is a relative path, prepend appropriate base API URL
 * - If profilePic is empty/null/undefined, return placeholder
 */
export const getUserProfileImage = (profilePic, size = 'original') => {
  if (!profilePic) {
    return profile_placeholder;
  }
  
  // Check if it's already a full URL
  if (profilePic.startsWith('http://') || profilePic.startsWith('https://')) {
    return profilePic;
  }
  
  // It's a relative path, prepend the appropriate base URL based on size
  const baseUrlMap = {
    'small': henceforthApi.API_FILE_ROOT_SMALL,
    'medium': henceforthApi.API_FILE_ROOT_MEDIUM,
    'original': henceforthApi.API_FILE_ROOT_ORIGINAL
  };
  
  const baseUrl = baseUrlMap[size] || baseUrlMap['original'];
  return `${baseUrl}${profilePic}`;
}